import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCreditCardFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.199 9.09a.3.3 0 0 0 .3-.3v-.08c0-2.794-1.794-4.67-4.464-4.67H6.964c-2.67 0-4.463 1.876-4.463 4.67v.08a.3.3 0 0 0 .3.3zM2.801 10.59a.3.3 0 0 0-.3.3v4.4c0 2.792 1.793 4.67 4.463 4.67h10.07c2.671 0 4.465-1.878 4.465-4.67v-4.4a.3.3 0 0 0-.3-.3z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCreditCardFilled);
export default ForwardRef;
